import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationIndividual7MasterReferenceData = createAsyncThunk(
  'stop/getVerificationIndividual7MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationIndividual7MasterReferenceSlice = createSlice({
  name: 'stop/verificationIndividual7MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationIndividual7MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationIndividual7MasterReferenceData.fulfilled]: (
      state,
      action
    ) => action.payload,
  },
});

export const { resetVerificationIndividual7MasterReference } =
  verificationIndividual7MasterReferenceSlice.actions;

export default verificationIndividual7MasterReferenceSlice.reducer;
